import { useEffect } from "react";

const setMetaTag = (attribute, key, content) => {
  if (!content) return;

  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setCanonical = (href) => {
  if (!href) return;

  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

function Seo({ title, description }) {
  useEffect(() => {
    const url = window.location.href;
    const socialTitle = title || "Mehmet Ali CELEBI";
    const socialDescription =
      description || "Portfolio and projects by Mehmet Ali CELEBI.";

    document.title = socialTitle;
    setCanonical(url);
    setMetaTag("name", "description", socialDescription);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:title", socialTitle);
    setMetaTag("property", "og:description", socialDescription);
    setMetaTag("property", "og:url", url);
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", socialTitle);
    setMetaTag("name", "twitter:description", socialDescription);
  }, [title, description]);

  return null;
}

export default Seo;
